import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';

const packs = [
  {
    id: 'starter',
    name: 'Starter',
    hours: 2,
    price: 2400000,
    originalPrice: 2400000,
    savings: 0,
    description: 'Perfect to try out',
    features: ['2 hours recording', '2 4K cameras', 'Technician included', '1 slot of 2h']
  },
  {
    id: 'pro',
    name: 'Pro',
    hours: 4,
    price: 4000000,
    originalPrice: 4800000,
    savings: 800000,
    description: 'Most popular',
    popular: true,
    features: ['4 hours recording', '2 4K cameras', 'Technician included', '2 slots of 2h', 'Save 800K IDR']
  },
  {
    id: 'elite',
    name: 'Elite',
    hours: 8,
    price: 8000000,
    originalPrice: 9600000,
    savings: 1600000,
    description: 'Maximum value',
    features: ['8 hours recording', '2 4K cameras', 'Technician included', '4 slots of 2h', 'Save 1.6M IDR']
  }
];

export const PacksSelection = ({ selectedPack, onSelectPack, formatIDR }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      transition={{ duration: 0.5 }}
    >
      <h2 className="text-3xl md:text-4xl font-heading font-semibold mb-8 text-center">Choose Your Pack</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {packs.map((pack) => (
          <div
            key={pack.id}
            onClick={() => onSelectPack(pack)}
            className={`cursor-pointer p-8 border-2 transition-all duration-300 relative ${
              selectedPack?.id === pack.id
                ? 'border-primary bg-primary/5'
                : 'border-border hover:border-primary/50'
            } ${pack.popular ? 'ring-2 ring-primary' : ''}`}
            data-testid={`pack-${pack.id}`}
          >
            {pack.popular && (
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 bg-primary text-primary-foreground text-xs font-bold uppercase tracking-wider">
                Popular
              </div>
            )}
            <div className="text-center mb-6">
              <h3 className="text-2xl font-heading font-bold mb-2">{pack.name}</h3>
              <p className="text-sm text-foreground-muted mb-4">{pack.description}</p>
              <div className="mb-2">
                {pack.savings > 0 && (
                  <span className="text-sm line-through text-foreground-muted mr-2">
                    {formatIDR(pack.originalPrice)}
                  </span>
                )}
                <div className="text-4xl font-heading font-bold text-primary">
                  {formatIDR(pack.price)}
                </div>
              </div>
              {pack.savings > 0 && (
                <div className="inline-block px-3 py-1 bg-primary/20 text-primary text-xs font-bold">
                  Save {formatIDR(pack.savings)}
                </div>
              )}
            </div>
            <ul className="space-y-3">
              {pack.features.map((feature, i) => (
                <li key={i} className="flex items-start gap-2 text-sm">
                  <Check className="w-4 h-4 text-primary mt-0.5 flex-shrink-0" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export { packs };